export default __webpack_public_path__ + "static/media/phone_act.94026461.svg";